import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kve-editor-footer',
  templateUrl: './editor-footer.component.html',
  styleUrls: ['./editor-footer.component.scss']
})
export class EditorFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
